


























































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
// import { Module, ModuleDataItem } from '@/models/Module'
import { Module } from '@/models/Module'
import { ModuleDataItem } from '@/models/ModuleDataItem'
import Datepicker from 'vuejs-datepicker'
import Select from '@/components/Select.vue'
import FileUpload from '@/components/FileUpload.vue'
import HTMLEditor from '@/components/HTMLEditor.vue'
import ModuleView from '@/views/module/Module.vue'

interface FormElement {
	id: number,
	label: string,
	main: string,
	module: string,
	name: string,
	options: object[],
	orderBy: number,
	required: number,
	searchable: number,
	type: string
}

@Component({
	components: {
		Datepicker,
		Select,
		FileUpload,
		HTMLEditor,
		'module-view': () => Promise.resolve(ModuleView),
	},
})
export default class ModuleItemForm extends Vue {
	@Prop({ default: null }) public editModuleItem!: ModuleDataItem
	@Prop() public formElements!: FormElement[]
	@Prop({ default: false }) public fullWidth!: boolean
	private moduleItem: ModuleDataItem = new ModuleDataItem()
	private fileValue: any = ''

	private created() {
		if (this.editModuleItem) {
			this.moduleItem = this.editModuleItem
			this.formElements.forEach((element: FormElement) => {
				// Fix the time items which use seconds while input type time is super funky with
				// seconds
				if (element.type === 'time' && this.moduleItem[element.name].length === 8) {
					this.moduleItem[element.name] = this.moduleItem[element.name].slice(0, 5)
				}
			})
		} else {
			this.formElements.forEach((element: FormElement) => {
				this.moduleItem.set(element.name, null)
			})
		}
	}

	@Watch('editModuleItem')
	private onEditModuleUpdate() {
		this.moduleItem = this.editModuleItem
	}

	private submit() {
		this.$validator.validateAll().then((result) => {
			if (!result) {
				console.log('form validation errors')
				return
			}
			this.$emit('submit', this.moduleItem)
		})
	}

	private isRequired(required: number) {
		if (required === 1) {
			return 'required'
		}
		return ''
	}

	private processFile(event: any) {
		console.log(event)
		const file = this.$refs.file as HTMLInputElement
		if (file.files && file.files.length > 0) {
			this.fileValue = file.files[0].name
			return
		}
		this.fileValue = ''
	}

	private updateDate(event: any, model: any) {
		const d = event
		const month = (`0${d.getMonth() + 1}`).slice(-2)
		const day = (`0${d.getDate()}`).slice(-2)
		const year = d.getFullYear()

		const date = `${year}-${month}-${day}`
		// @ts-ignore
		this.moduleItem[model] = date
	}
}
